import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import store from "./store";
import { createI18n } from 'vue-i18n';
import messages from "./i18n";

// 手机端 Console：?debug=1 或 localStorage.otcpro_debug_console=1 时加载 vConsole（CDN）
if (typeof window !== 'undefined' && import.meta.env.MODE !== 'production') {
  const need = new URL(window.location.href).searchParams.get('debug') === '1' || localStorage.getItem('otcpro_debug_console') === '1';
  if (need) {
    const s = document.createElement('script');
    s.src = 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js';
    s.onload = () => { (window as any).VConsole && new (window as any).VConsole(); };
    document.head.appendChild(s);
  }
}

import "ant-design-vue/dist/antd.less";
import VueGtag from "vue-gtag-next";
import { message, Modal, notification } from 'ant-design-vue'
import logger from './utils/logger';

// 读取环境变量
const CLIENT_ID = import.meta.env.VITE_CLIENT_ID || 'unknown';
logger.log('========================================');
logger.log(`VITE_CLIENT_ID: ${CLIENT_ID}`);
logger.log(`Environment: ${import.meta.env.MODE}`);
logger.log(`API Base URL: ${import.meta.env.VITE_API_BASE_URL}`);
const GA_MEASUREMENT_ID = (import.meta.env.VITE_GA_MEASUREMENT_ID || '').trim();
logger.log(`GA Measurement ID: ${GA_MEASUREMENT_ID || '(disabled)'}`);
logger.log('========================================');

const app = createApp(App);

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages,
})

// 打印当前 i18n locale，便于排查为什么一直显示英文
const currentLocale = typeof i18n.global.locale === 'object' ? (i18n.global.locale as any).value : i18n.global.locale;
logger.log('[i18n] locale:', currentLocale);
logger.log('[i18n] fallbackLocale:', i18n.global.fallbackLocale);
logger.log('[i18n] available locales:', Object.keys(messages));

app.config.globalProperties.$notification = notification;
app.config.globalProperties.$message = message;
app.config.globalProperties.$confirm = Modal.confirm;
app.config.globalProperties.$info = Modal.info;
app.config.globalProperties.$logger = logger;

if (GA_MEASUREMENT_ID) {
    app.use(VueGtag, {
        property: {
            id: GA_MEASUREMENT_ID,
        },
    });
}
app.use(router);
app.use(i18n);
app.use(store);

// 检查是否为 Zp 渠道
if (typeof window !== 'undefined') {
    const ethereum = (window as any).ethereum;
    logger.log('window.ethereum:', ethereum);

    if (ethereum) {
        // 获取所有属性和方法
        const methods = Object.getOwnPropertyNames(Object.getPrototypeOf(ethereum))
            .filter(name => typeof ethereum[name] === 'function');

        const properties = Object.keys(ethereum).filter(key => typeof ethereum[key] !== 'function');

        const info = {
            isMetaMask: ethereum.isMetaMask,
            chainId: ethereum.chainId,
            selectedAddress: ethereum.selectedAddress,
            methods: methods,
            properties: properties
        };

        logger.log('window.ethereum 详细信息:', info);
        logger.log('window.ethereum 挂载的方法:', methods);
        logger.log('window.ethereum 的属性:', properties);

        // 检查是否为 Zp 渠道
        if (ethereum.eth_mimo) {
            logger.log('检测到 Zp 渠道 (window.ethereum.eth_mimo 存在)');
            store.commit('setZpChannel', true);
        } else {
            logger.log('普通渠道 (未检测到 window.ethereum.eth_mimo)');
            store.commit('setZpChannel', false);
        }
    } else {
        logger.log('未检测到 window.ethereum');
        store.commit('setZpChannel', false);
    }
}
// store.commit('setZpChannel', true);
// store.commit('setZpChannel', true);
app.mount('#app');

// 再次打印 locale（应用挂载后）
const localeAfterMount = typeof i18n.global.locale === 'object' ? (i18n.global.locale as any).value : i18n.global.locale;
logger.log('[i18n] locale after mount:', localeAfterMount);

// 检查并打印 window.ethereum
if (typeof window !== 'undefined') {
    const ethereum = (window as any).ethereum;
    logger.log('window.ethereum:', ethereum);

    if (ethereum) {
        // 获取所有属性和方法
        const methods = Object.getOwnPropertyNames(Object.getPrototypeOf(ethereum))
            .filter(name => typeof ethereum[name] === 'function');

        const properties = Object.keys(ethereum).filter(key => typeof ethereum[key] !== 'function');

        const info = {
            isMetaMask: ethereum.isMetaMask,
            chainId: ethereum.chainId,
            selectedAddress: ethereum.selectedAddress,
            methods: methods,
            properties: properties
        };

        logger.log('window.ethereum 详细信息:', info);
        logger.log('window.ethereum 挂载的方法:', methods);
        logger.log('window.ethereum 的属性:', properties);
    } else {
        logger.log('未检测到 window.ethereum');
    }
}